"use strict";

// Keep both identifiers populated because legacy site records can be keyed by
// either numeric site IDs or short codes depending on the payload shape. Only
// these clinics should remain selectable in the legacy portal dropdown.
const ENABLED_LEGACY_CLINIC_IDS = new Set([]);
const ENABLED_LEGACY_CLINIC_CODES = new Set([]);
const DISABLED_CLINIC_SUFFIX = " (moved to XOP)";

const isLegacyClinicEnabled = (site) => {
  if (!site) return false;

  return (
    ENABLED_LEGACY_CLINIC_IDS.has(String(site.id)) ||
    ENABLED_LEGACY_CLINIC_CODES.has(String(site.code).toLowerCase())
  );
};

const isLegacyClinicDisabled = (site) => {
  if (!site) return false;

  return !isLegacyClinicEnabled(site);
};

const getLegacyClinicOptionLabel = (site) => {
  if (!site) return "";
  return isLegacyClinicDisabled(site)
    ? `${site.name}${DISABLED_CLINIC_SUFFIX}`
    : site.name;
};

const getFallbackLegacyClinic = (sites = []) => {
  return sites.find((site) => !isLegacyClinicDisabled(site)) || sites[0] || {};
};

module.exports = {
  getFallbackLegacyClinic,
  getLegacyClinicOptionLabel,
  isLegacyClinicDisabled,
};
